export default __webpack_public_path__ + "static/void_warlock-bd17c1.svg";